import React from 'react';
import { I18n } from 'react-redux-i18n';

import { MuiThemeProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import grey from '@material-ui/core/colors/grey';

import themeConfig from './../theme-config';
import ThemeDefault from '../theme-default';

const styles = {
  title: {
    textAlign: 'center',
    fontSize: '24px',
    color: grey[50],
    paddingBottom: '20px',
  },
  logoLife: {
    height: 200,
    width: 400,
  },
  loginContainer: {
    width: 450,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  paper: {
    padding: 10,
    overflow: 'auto',
  },
  buttonsDiv: {
    textAlign: 'center',
    padding: 10,
  },
  flatButton: {
    color: grey[500],
  },
};

export default class LoginPage2 extends React.Component {

  componentWillMount() {

    const body = document.querySelector('body');
    body.style.background = "#efefef no-repeat center center fixed";
    body.style.backgroundSize = 'cover';

  }

  render() {

    return (
      <MuiThemeProvider theme={ThemeDefault}>
        <div style={styles.loginContainer}>

          <Paper style={styles.paper} >
            <img style={styles.logoLife} src={themeConfig.logo} alt="logo" />
            Sessão finalizada com sucesso
          </Paper>

        </div>
      </MuiThemeProvider>
    );

  }
}



// WEBPACK FOOTER //
// ./src/containers/LoginPage2.js